/**
 * The member's emailStatus (UserCredentials::emailStatus): 1 all e-mail,
 * 2 new messages only, 0 unconfirmed, -1 no e-mail, -2 hard bounce, -3 complaint.
 */
export const EMAIL_STATUS_BOUNCED = -2;

interface CredentialsLike {
  emailStatus?: number | null;
  passwordSetByUser?: number | null;
}

/** Mail to the address hard-bounced: the member is asked to correct it. */
export const isEmailBounced = (credentials?: CredentialsLike | null): boolean =>
  Number(credentials?.emailStatus) === EMAIL_STATUS_BOUNCED;

/**
 * Unconfirmed address: the only status where verifying (or resending the
 * activation mail) applies. -1 (unsubscribed) and -3 (complaint) have working
 * addresses that just opted out, and resendActivation() refuses them anyway.
 */
export const isEmailUnconfirmed = (credentials?: CredentialsLike | null): boolean =>
  Number(credentials?.emailStatus) === 0;

/**
 * Mirrors UserCredentials::changeEmailRequiresPassword(): a member who never
 * chose a password may correct an unconfirmed (or bounced) address without one.
 */
export const changeEmailRequiresPassword = (credentials?: CredentialsLike | null): boolean =>
  !(Number(credentials?.passwordSetByUser) === 0 && Number(credentials?.emailStatus) !== 1);
